import { BookingDemo } from "./BookingDemo";
import { QrDemo } from "./QrDemo";
import { ReviewsDemo } from "./ReviewsDemo";
import { OrderDemo } from "./OrderDemo";
import { WheelDemo } from "./WheelDemo";
import { RaceDemo } from "./RaceDemo";
import { GiftBoxDemo } from "./GiftBoxDemo";

const MAP = { booking: BookingDemo, qr: QrDemo, reviews: ReviewsDemo, order: OrderDemo, wheel: WheelDemo, race: RaceDemo, giftbox: GiftBoxDemo };

export const DEMO_TYPES = [
  { key: "booking", label: "Online rezervasiya" },
  { key: "qr", label: "QR Loyalty" },
  { key: "reviews", label: "Review sistemi" },
  { key: "order", label: "Online sifariş" },
  { key: "wheel", label: "TikTok Çarx" },
  { key: "race", label: "TikTok Race" },
  { key: "giftbox", label: "TikTok Gift Box" },
];

export const DemoRenderer = ({ type, businessKey }) => {
  const C = MAP[type];
  return C ? (
    <div className="rounded-2xl bg-[#111110]/70 border border-white/[0.08] p-4" data-testid="interactive-demo-container">
      <C businessKey={businessKey} />
    </div>
  ) : null;
};
